const ArgumentType = require("../../extension-support/argument-type");
const Cast = require("../../util/cast");
const BlockType = require("../../extension-support/block-type");
const formatMessage = require("format-message");
const log = require('../../util/log');

/**
 * Url of icon to be displayed at the left edge of each extension block.
 * @type {string}
 */
// eslint-disable-next-line max-len
const iconURI =
    "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSIjRkZGRkZGIj48cGF0aCBkPSJNMTIgMTRjMS42NiAwIDIuOTktMS4zNCAyLjk5LTNMMTUgNWMwLTEuNjYtMS4zNC0zLTMtM1M5IDMuMzQgOSA1djZjMCAxLjY2IDEuMzQgMyAzIDN6bTUuMy0zYzAgMy0yLjU0IDUuMS01LjMgNS4xUzYuNyAxNCA2LjcgMTFINWMwIDMuNDEgMi43MiA2LjIzIDYgNi43MlYyMWgydi0zLjI4YzMuMjgtLjQ4IDYtMy4zIDYtNi43MmgtMS43eiIvPjxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiLz48L3N2Zz4K";

/**
 * Url of icon to be displayed in the toolbox menu for the extension category.
 * @type {string}
 */
// eslint-disable-next-line max-len
const menuIconURI =
    "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNHB4IiBoZWlnaHQ9IjI0cHgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iIzc1NzU3NSI+CiAgICA8cGF0aCBkPSJNMTIgMTRjMS42NiAwIDIuOTktMS4zNCAyLjk5LTNMMTUgNWMwLTEuNjYtMS4zNC0zLTMtM1M5IDMuMzQgOSA1djZjMCAxLjY2IDEuMzQgMyAzIDN6bTUuMy0zYzAgMy0yLjU0IDUuMS01LjMgNS4xUzYuNyAxNCA2LjcgMTFINWMwIDMuNDEgMi43MiA2LjIzIDYgNi43MlYyMWgydi0zLjI4YzMuMjgtLjQ4IDYtMy4zIDYtNi43MmgtMS43eiIvPgogICAgPHBhdGggZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIvPgo8L3N2Zz4K";

const AvailableLocales = ['en', 'ja', 'ja-Hira'];

const Message = {
    webkitLang: {
        'ja': 'ja-JP',
        'ja-Hira': 'ja-JP',
        'en': 'en-US',
    },
    categoryName: {
        'ja': '音声認識',
        'ja-Hira': 'おんせいにんしき',
        'en': 'Speech2Text',
    },
    listen: {
        'ja': 'マイクをON',
        'ja-Hira': 'マイクをオン',
        'en': 'Mic ON',
    },
    stop: {
        'ja': 'マイクをOFF',
        'ja-Hira': 'マイクをオフ',
        'en': 'Mic OFF',
    },
    reset: {
        'ja': '結果を消す',
        'ja-Hira': 'けっかをけす',
        'en': 'Clear result',
    },
    result: {
        'ja': '結果',
        'ja-Hira': 'もじ',
        'en': 'Result',
    },
    whenIHear: {
        'ja': '[phrase] を聞いたとき',
        'ja-Hira': '[phrase] をきいたとき',
        'en': 'When I hear [phrase]',
    },
    defaultPhrase: {
        'ja': 'こんにちは',
        'ja-Hira': 'こんにちは',
        'en': 'hello',
    },
    notAvailable: {
        'ja': 'ブラウザが対応していません',
        'ja-Hira': '',
        'en': '',
    },
    stopped: {
        'ja': '停止中',
        'ja-Hira': 'ていしちゅう',
        'en': 'stopped',
    },
    listening: {
        'ja': '',
        'ja-Hira': '',
        'en': '',
    }
}

class kurikitSpeech2TextBlocks {
    constructor(runtime) {
        this.runtime = runtime;

        this._recognition = null;
        this._currentUtterance = "";
        this._isStarted = false;
        this._currentLanguage = "ja-JP";

        // webkitSpeechRecognition settings
        this.continuous = true;
        this.interimResults = false;
    }

    /**
     * @returns {object} Metadata for this extension and its blocks.
     */
    getInfo() {
        return {
            id: "webkitrecognition",
            name: Message.categoryName[this.setLocale()],
            menuIconURI: menuIconURI,
            blockIconURI: iconURI,
            blocks: [
                {
                    opcode: "listen",
                    text: Message.listen[this.setLocale()],
                    blockType: BlockType.COMMAND,
                },
                {
                    opcode: "stop",
                    text: Message.stop[this.setLocale()],
                    blockType: BlockType.COMMAND,
                },
                {
                    opcode: "reset",
                    text: Message.reset[this.setLocale()],
                    blockType: BlockType.COMMAND,
                },
                {
                    opcode: "getSpeech",
                    text: Message.result[this.setLocale()],
                    blockType: BlockType.REPORTER,
                },
                {
                    opcode: "whenIHearHat",
                    text: Message.whenIHear[this.setLocale()],
                    blockType: BlockType.HAT,
                    arguments: {
                        phrase: {
                            type: ArgumentType.STRING,
                            defaultValue: Message.defaultPhrase[this.setLocale()],
                        },
                    },
                },
            ],
        };
    }

    /**
     * Start the listening process if it isn't already in progress.
     * @return {Promise} A promise that will resolve when listening is complete.
     */
    listen() {
        const speechRecognition = window.webkitSpeechRecognition || window.SpeechRecognition;
        if (speechRecognition) {
            window.SpeechRecognition = speechRecognition;
        }
        var available = Boolean(speechRecognition);
        if (!available) {
            this._currentUtterance = Message.notAvailable[this.setLocale()];
            return;
        }

        var isChanged = false;
        if (this._currentLanguage != Message.webkitLang[this.setLocale()]){
            if (this._recognition != null) {
                this._recognition.stop();    
                isChanged = true;
            }
        }

        if (this._recognition == null || isChanged) {
            this._currentLanguage = Message.webkitLang[this.setLocale()];

            this._recognition = new window.SpeechRecognition();
            this._recognition.continuous = this.continuous;
            this._recognition.interimResults = this.interimResults;
            this._recognition.lang = Message.webkitLang[this.setLocale()];
            this._recognition.maxAlternatives = 1;
            this._recognition.onspeechstart = (e) => {
                this._currentUtterance = Message.listening[this.setLocale()];
            };
            this._recognition.onresult = (e) => {
                var result = e.results[e.results.length - 1][0].transcript;
                this._currentUtterance = result.trim();
            };
        }

        if (this._isStarted) {
            return;
        }
        this._recognition.start();
        this._isStarted = true;
        this._currentUtterance = "";
    }

    stop() {
        this._currentUtterance = Message.stopped[this.setLocale()];
        if (this._recognition != null) {
            this._recognition.stop();
            this._isStarted = false;
        }
    }

    reset() {
        this._currentUtterance = "";
    }

    whenIHearHat(args) {
        if (this._isStarted && this._currentUtterance != "") {
            log.log(args.phrase + "," + this._currentUtterance);
            if (args.phrase == this._currentUtterance) {
                return true;
            }
        }
        return false;
    }

    getSpeech() {
        return this._currentUtterance;
    }

    setLocale() {
        let locale = formatMessage.setup().locale;
        if (AvailableLocales.includes(locale)) {
            return locale;
        } else {
            return 'en';
        }
    }
}

module.exports = kurikitSpeech2TextBlocks;
